// @flow
import * as React from 'react';
import { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import TitledCard from 'common/components/cards/TitledCard';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { ChromePicker } from 'react-color';
import { Label, MargedBlock, ColorPickerContainer } from '../../styles';
import StationLinkComponent from './StationLinkComponent';
import { StationLink } from '../../../domain/StationLink';
import type { StatsRadioPlayerStationInformationData, StatsRadioPlayerThemeData } from '../../../domain/PlayerConfiguration';
import StationInformationsDemo from './demos/StationInformationsDemo';

type Props = {
  data: StatsRadioPlayerStationInformationData;
  demoTheme: StatsRadioPlayerThemeData;
  onValueChange: (key: string, value: any) => any;
  onThemeChange: (data: Object) => any;
  t: any;
  theme: Object;
}

type State = {
  linkHeaderColor: string;
  linkHeaderTextColor: string;
  linkBackgroundColor: string;
  linkTextColor: string;
}

class StationInformation extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    const theme = props.demoTheme.stationInformation;

    this.state = {
      linkHeaderColor: theme.linkHeaderColor,
      linkHeaderTextColor: theme.linkHeaderTextColor,
      linkBackgroundColor: theme.linkBackgroundColor,
      linkTextColor: theme.linkTextColor,
    };
  }

  onAddLink = () => {
    const links = this.props.data.links;
    links.push({
      name: '',
      url: 'http://',
    });

    this.saveLinks(links);
  }

  onDeleteLink(index: number) {
    const links = this.props.data.links;
    links.splice(index, 1);

    this.saveLinks(links);
  }

  onUpdateLink(index: number, name: string, url: string) {
    const links = this.props.data.links;
    links[index].name = name;
    links[index].url = url;

    this.saveLinks(links);
  }

  onColorChange(key, value) {
    this.setState({ [key]: value.hex });
  }

  onColorChangeComplete(key, value) {
    const data = {
      ...this.props.demoTheme.stationInformation,
      [key]: value.hex,
    };

    this.props.onThemeChange(data);
  }

  saveLinks(links: Array<StationLink>) {
    this.props.onValueChange('links', links);
  }

  render() {
    const { data, demoTheme, t, theme } = this.props;
    let linkKeyNumber = 0;

    return (
      <TitledCard title={t('stationInformations')}>
        <div className="row">
          <div className="col-xs-6">
            <Label withPadding>{t('doYouWantAnInformationSection')}</Label>
            <RadioButtonGroup
              name="doYouWantAnInformationSection"
              onChange={(e, v) => this.props.onValueChange('display', v)}
              defaultSelected={data.display}
            >
              <RadioButton
                value
                label={t('yes')}
              />
              <RadioButton
                value={false}
                label={t('no')}
              />
            </RadioButtonGroup>
            { data.display &&
              <div>
                <MargedBlock>
                  <Label>{t('informationSectionTitle')}</Label>
                  <TextField
                    onChange={(e, v) => this.props.onValueChange('name', v)}
                    value={data.name}
                    fullWidth
                    id="title"
                  />
                </MargedBlock>
                <Label>{t('description')}</Label>
                <TextField
                  onChange={(e, v) => this.props.onValueChange('description', v)}
                  value={data.description}
                  fullWidth
                  multiLine
                  id="description"
                />
                <Label withPadding>{t('stationLinks')}</Label>
                <section>
                  { data.links.map((link, index) => {
                    linkKeyNumber++;
                    return (
                      <StationLinkComponent
                        key={linkKeyNumber}
                        link={link}
                        onDelete={() => this.onDeleteLink(index)}
                        onUpdate={(title, url) => this.onUpdateLink(index, title, url)}
                      />
                    );
                  })
                  }
                </section>
                <RaisedButton
                  onClick={this.onAddLink}
                  style={{ backgroundColor: theme.colors.primaryBackground }}
                  labelStyle={{ color: theme.colors.primary }}
                  label={t('addLink')}
                  icon={<i className="material-icons" style={{ color: theme.colors.primary }}>add_circle</i>}
                />
              </div>
            }
          </div>
          <div className="col-xs-6">
            { data.display &&
              <StationInformationsDemo
                data={data}
                demoTheme={demoTheme}
                colors={this.state}
              />
            }
          </div>
        </div>
        { data.links.length > 0 &&
          <MargedBlock className="row">
            <ColorPickerContainer className="col-xs-4 col-md-3">
              <Label withPadding>{t('linkHeaderBackgroundColor')}</Label>
              <ChromePicker
                color={this.state.linkHeaderColor}
                onChange={color => this.onColorChange('linkHeaderColor', color)}
                onChangeComplete={color => this.onColorChangeComplete('linkHeaderColor', color)}
              />
            </ColorPickerContainer>
            <ColorPickerContainer className="col-xs-4 col-md-3">
              <Label withPadding>{t('linkHeaderTextColor')}</Label>
              <ChromePicker
                color={this.state.linkHeaderTextColor}
                onChange={color => this.onColorChange('linkHeaderTextColor', color)}
                onChangeComplete={color => this.onColorChangeComplete('linkHeaderTextColor', color)}
              />
            </ColorPickerContainer>
            <ColorPickerContainer className="col-xs-4 col-md-3">
              <Label withPadding>{t('linkBackgroundColor')}</Label>
              <ChromePicker
                color={this.state.linkBackgroundColor}
                onChange={color => this.onColorChange('linkBackgroundColor', color)}
                onChangeComplete={color => this.onColorChangeComplete('linkBackgroundColor', color)}
              />
            </ColorPickerContainer>
            <ColorPickerContainer className="col-xs-4 col-md-3">
              <Label withPadding>{t('linkTextColor')}</Label>
              <ChromePicker
                color={this.state.linkTextColor}
                onChange={color => this.onColorChange('linkTextColor', color)}
                onChangeComplete={color => this.onColorChangeComplete('linkTextColor', color)}
              />
            </ColorPickerContainer>
          </MargedBlock>
        }
      </TitledCard>
    );
  }
}

export default withTheme(translate('radioConfiguration')(StationInformation));



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/playerConfigurationForm/statsRadioPlayer/StationInformation.js